import httpClient from '../../httpClient';

/**
 * 비밀번호 변경 APi
 * @typedef {Object}
 * @param {string} userEmail - user email
 * @param {string} authCode - authCode
 * @param {string} userPassword - user new password
 * @returns {Promise}
 */
function userChangePassword({ userEmail, userPassword, authCode }) {
  return httpClient({
    url: `/user/password`,
    method: 'POST',
    data: {
      user_email: userEmail,
      user_password: userPassword,
      authCode,
    },
  });
}

export default userChangePassword;
